<template>
  <div v-if="cart" :class="['cart-large', { 'shadow-none': isMobile, 'pb-20': !isMobile }]">
    <div :class="[
      'header mt-0 align-items-center d-flex',
      {
        'border-bottom-0 shadow-sm': isMobile,
        'p-0': isMobile && title === 'Review and Place Order',
        'px-2': isMobile && (title === 'My Cart' || title === 'Order Summary'),
        'mx-0': isMobile
      },
    ]" v-if="type == 'big'">
      <div class="d-inline d-md-none mr-3 cursor-pointer position-relative" @click="$router.go(-1)" v-if="title === 'My Cart' || title === 'Order Summary'" :style="{ 'z-index': 1 }">
        <img src="@/assets/images/ic-arrow-left.svg" alt="Left Arrow" />
      </div>
      <h2 :class="['mb-0 flex-grow-1 fw-bold', { 'text-center offset-page-header': isMobile && brandBranches.length === 1 }]"
        v-if="!isMobile || title === 'My Cart' || title === 'Order Summary'">
        {{ isMobile && source === 'Checkout' ? source : title }}

        <div class="row position-relative w-100 no-gutters" v-if="cart && cart.cart_count >= 1">
          <div
            :class="['align-content-center', { 'col-6': !isMobile || isMobile && brandBranches.length > 1, 'col-12': isMobile && brandBranches.length === 1 }]">
            <span class="text-muted branch-count" v-if="brandBranch.length > 1">{{ brandBranch.length + ' branches'
              }}</span>
            <span class=" branch-count" v-else>{{ brandBranch[0].brand }} ({{ brandBranch[0].branch }})</span>
          </div>
          <div class="col-6 text-right" v-if="!isMobile || isMobile && brandBranches.length > 1">
            <ClearCartComponent :webDesign="webDesign" :source="source" @confirmRemoveAll="confirmRemoveAll" />
          </div>
        </div>
      </h2>
    </div>

    <div :class="['cart-body py-2', {
      'my-3 mx-2 collapsible-border-rounded py-1': source === 'Checkout' && isMobile,
      'scrollable': source === 'navbar'
    }]" v-if="cart.cart_count">
      <CollapsiblePortionComponent v-if="isMobile && source === 'Checkout'" :toggle="title">
        <template slot="title">{{ title }}</template>
      </CollapsiblePortionComponent>
      <b-collapse visible :id="`collapse-toggle-${title.replace(/ /g, '-').toLowerCase()}`" class="mt-2"
        v-if="isMobile">
        <CartItemsComponent :brandBranches="brandBranches" :brandBranch="brandBranch" :cart="cart"
          :showFulfillment="showFulfillment" :isBranchDetailsDataLoaded="isBranchDetailsDataLoaded"
          :formattedOrders="formattedOrders" :source="source" @selectBranchLogisticType="selectBranchLogisticType"
          @showScheduleModal="showScheduleModal" @confirmRemoveAll="confirmRemoveAll" @confirmRemove="confirmRemove"
          @removeItem="removeItem"
          @showModal="showModal"
          @addMoreItems="addMoreItems" />
        <ComputationBreakdownComponent v-if="cart" cssClass="px-0 border-top px-3" :cart="cart"
          :showTotal="source === 'View Cart'" />
      </b-collapse>
      <template v-else>
        <CartItemsComponent :brandBranches="brandBranches" :brandBranch="brandBranch" :cart="cart"
          :showFulfillment="showFulfillment" :isBranchDetailsDataLoaded="isBranchDetailsDataLoaded"
          :formattedOrders="formattedOrders" :source="source" @selectBranchLogisticType="selectBranchLogisticType"
          @showScheduleModal="showScheduleModal" @confirmRemoveAll="confirmRemoveAll" @confirmRemove="confirmRemove"
          @removeItem="removeItem"
          @showModal="showModal"
          @addMoreItems="addMoreItems" />
      </template>
    </div>
    <div class="cart-empty py-4" v-if="cart.list.length === 0">
      <p style="text-align: center">
        No items in the cart yet.
      </p>
    </div>
    <div v-if="source === 'Checkout' && loggedIn" id="discount-section" @click="$bvModal.show('discount-modal')"
      :class="[{ 'px-4 pt-3 border-top container': !isMobile, 'px-2 mb-3': isMobile }]">
      <div
        :class="['w-100', { 'collapsible-border-rounded px-3 py-3': isMobile && source === 'Checkout' && loggedIn }]">
        <div class="d-flex align-items-center">
          <CheckCircleIcon v-if="!!appliedDiscount" :fill="webDesign.design.main_color" />
          <TagIcon v-else />
          <span :class="['ml-2', { 'fw-bold': isMobile }]" :style="{ 'font-size': isMobile ? '18px' : null }">Apply a
            discount</span>
        </div>
        <div class="d-flex align-items-center">
          <div v-if="!!appliedDiscount" class="promo-coupon mr-2">{{ appliedDiscount }}</div>
          <ChevronRightIcon :fill="webDesign.design.main_color" />
        </div>
      </div>
    </div>
    <ProductModal ref="modal"></ProductModal>
    <ScheduleModal :brand-branch="selectedBrandBranch" ref="scheduleModal" />
    <DiscountModal />
    <ViewAvailableCodesModal />
    <UploadSpecialDiscountIdModal />
    <ConfirmDeleteSpecialDiscountIdModal />
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import ProductModal from "@/components/cart/ProductModal";
import ScheduleModal from "@/components/cart/ScheduleModal";
import DiscountModal from "@/components/cart/DiscountModal";
import ViewAvailableCodesModal from "@/components/cart/ViewAvailableCodesModal";
import UploadSpecialDiscountIdModal from "@/components/special-discount/UploadSpecialDiscountIdModal";
import ConfirmDeleteSpecialDiscountIdModal from "@/components/special-discount/ConfirmDeleteSpecialDiscountIdModal.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon";
import TagIcon from "@/components/icons/TagIcon";
import CheckCircleIcon from "@/components/icons/CheckCircleIcon";
import ClearCartComponent from "./ClearCartComponent.vue";
import CollapsiblePortionComponent from "../common/CollapsiblePortionComponent.vue";
import CartItemsComponent from "./CartItemsComponent.vue";
import ComputationBreakdownComponent from "./ComputationBreakdownComponent.vue";
import _ from "lodash";

export default {
  name: "Cart",
  components: {
    ProductModal,
    ScheduleModal,
    DiscountModal,
    ViewAvailableCodesModal,
    UploadSpecialDiscountIdModal,
    ConfirmDeleteSpecialDiscountIdModal,
    ChevronRightIcon,
    TagIcon,
    CheckCircleIcon,
    ClearCartComponent,
    CollapsiblePortionComponent,
    CartItemsComponent,
    ComputationBreakdownComponent
  },
  props: ["title", "type", "editable", "showFulfillment", "source"],
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      authErrors: (state) => state.errors,
      authIsLoading: (state) => state.loading,
    }),
    ...mapState("merchant", {
      subdomain: (state) => state.subdomain,
      customerPortalToken: (state) => state.customerPortalToken,
      merchantIsLoading: (state) => state.loading,
      merchantErrors: (state) => state.errors,
    }),
    ...mapState("branch", {
      branches: (state) => state.branches,
      branchesNearby: (state) => state.branchesNearby,
      branchesErrors: (state) => state.errors,
      branchesIsLoading: (state) => state.loading,
      coordinates: (state) => state.coordinates,
    }),
    ...mapState("estore", {
      cart: (state) => state.cart,
      products: (state) => state.products,
      estoreIsLoadingOverlay: (state) => state.loadingOverlay,
      estoreIsLoading: (state) => state.loading,
      estoreErrors: (state) => state.errors,
      webDesign: (state) => state.webDesign,
      deliverPickUp: (state) => state.deliverPickUp,
      cartSpecialDiscount: (state) => state.cartSpecialDiscount,
    }),
    ...mapState("organization", ["branchDetails"]),
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      firstBranchNearby: "branch/firstBranchNearby",
      getDeliveryConfig: "estore/getDeliveryConfig",
      cartUuid: "estore/cartUuid",
      isSpecialDiscountEnabled: "estore/isSpecialDiscountEnabled",
      isMobile: "isMobile/isMobile"
    }),
    cartPromoCode() {
      return _.get(this.cart, "voucher_info.code", "");
    },
    appliedDiscount() {
      return this.isSpecialDiscountEnabled && this.cartSpecialDiscount ?
        this.specialDiscountLabel[this.cartSpecialDiscount.discount_type] :
        _.truncate(this.cartPromoCode, { length: 11 });
    }
  },
  created: async function () {
    await this.formatData();
    this.$root.$on("refreshCartItems", async () => {
      await this.viewCart();
      await this.formatData();
    });
  },
  data() {
    return {
      isConfirmRemove: false,
      brandBranches: null,
      brandBranch: null,
      formattedOrders: null,
      visible: true,
      removeAllModal: false,
      selectedDelivery: null,
      showOptions: false,
      deliverLaterDates: null,
      selectedDeliverLaterDate: null,
      timeOptions: [],
      selectedTime: null,
      selectedPickupTime: null,
      pickUpLaterDates: null,
      selectedPickUpLaterDate: null,
      cutoffMessage: null,
      isBranchDetailsDataLoaded: false,
      selectedBrandBranch: null,
      addItemAlignment: "center",
      specialDiscountLabel: {
        senior: "Senior Citizen",
        pwd: "PWD"
      },
    };
  },
  mounted() {
    this.$root.$on("confirmRemoveAllCartItems", (callback) => {
      this.confirmRemoveAll();

      if (callback) callback();
    });
  },
  methods: {
    getMoment(data, type) {
      if (type == "date") {
        return moment(data).format("MMM DD, YYYY");
      } else {
        return moment(data).format("h:mm A");
      }
    },
    getBrandBranch() {
      if (this.cart && this.cart.list) {
        let brandBranch = this.cart.list.map((obj) => {
          let newBrand = {};
          newBrand["brand"] = obj.brand_name;
          newBrand["brand_uuid"] = obj.brand_uuid;
          newBrand["branch"] = obj.branch_name;
          newBrand["branch_uuid"] = obj.branch_uuid;
          newBrand["removeAllModal"] = false;
          newBrand["logisticType"] = obj.delivery_type;
          newBrand["scheduledDate"] = obj.pickup_datetime;
          newBrand["fees"] = obj.fees;
          newBrand["deliveryOptions"] = false;
          newBrand["dateTime"] = false;
          return newBrand;
        });
        this.brandBranch = brandBranch;
        this.brandBranches = brandBranch;
      }
    },
    formatOrders() {
      if (this.cart && this.cart.list) {
        let brandBranch = this.brandBranch;

        let newCart = [];
        for (let h = 0; h < brandBranch.length; h++) {
          for (let i = 0; i < this.cart.list.length; i++) {
            for (let j = 0; j < this.cart.list[i].items.length; j++) {
              if (
                this.cart.list[i].items[j].branch_name ==
                brandBranch[h].branch &&
                this.cart.list[i].items[j].brand_name == brandBranch[h].brand
              ) {
                newCart.push({
                  branch: brandBranch[h].branch,
                  brand: brandBranch[h].brand,
                  branch_uuid: brandBranch[h].branch_uuid,
                  name: this.cart.list[i].items[j].product_inventory
                    .product_details.name,
                  description:
                    this.cart.list[i].items[j].product_inventory.product_details
                      .description,
                  quantity: parseInt(this.cart.list[i].items[j].quantity),
                  total_amount: this.cart.list[i].items[j].total_amount,
                  image:
                    this.cart.list[i].items[j].product_inventory.product_details
                      .images.length > 0
                      ? this.cart.list[i].items[j].product_inventory
                        .product_details.images[0].image_name
                      : null,
                  product_uuid:
                    this.cart.list[i].items[j].product_inventory.product_details
                      .uuid,
                  item_uuid: this.cart.list[i].items[j].uuid,
                  visible: false,
                  product_type:
                    this.cart.list[i].items[j].product_inventory.product_details
                      .type,
                  decoded_variation:
                    this.cart.list[i].items[j].product_inventory
                      .decoded_variation_code,
                  stock: this.cart.list[i].items[j].product_inventory.stock,
                  is_limited_stock:
                    this.cart.list[i].items[j].product_inventory
                      .is_limited_stock,
                  add_ons: this.cart.list[i].items[j].add_ons,
                  remarks: this.cart.list[i].items[j].remarks
                });
              }
            }
          }
        }
        this.formattedOrders = newCart;
      }
    },
    async viewCart() {
      if (
        this.customerPortalToken &&
        !_.isEmpty(this.coordinates)
      ) {
        this.isBranchDetailsDataLoaded = false;
        const header = {
          "X-Merchant-Token": this.customerPortalToken
        };
        const payload = {
          customer_lat: this.coordinates.lat,
          customer_lng: this.coordinates.long,
        }

        if (this.token)
          header["Authorization"] = this.token;

        if (this.cartUuid && !this.token)
          payload.cart_uuid = this.cartUuid;

        const request = {
          header,
          payload,
        };

        await this.$store.dispatch("estore/viewCart", request);
      }
    },
    async formatData() {
      this.getBrandBranch();
      this.formatOrders();

      if (this.showFulfillment && this.cart && this.cart.list) {
        this.isBranchDetailsDataLoaded = false;

        const branchDetailsPromises = this.brandBranch.map(
          async (item, index) => {
            await this.getBranchDetails(item.branch_uuid);

            const {
              deliver_now,
              scheduled_delivery,
              pickup_now,
              scheduled_pickup,
            } = this.branchDetails;

            const logisticTypeOptions = {
              ...(deliver_now.enable && { deliver_now }),
              ...(scheduled_delivery.enable && { scheduled_delivery }),
              ...(pickup_now.enable && { pickup_now }),
              ...(scheduled_pickup.enable && { scheduled_pickup }),
            };
            let selectedLogisticType = "";

            if (
              item.logisticType === "Delivery" &&
              logisticTypeOptions.deliver_now
            ) {
              selectedLogisticType = "deliver_now";
            }

            if (
              item.logisticType === "Pickup" &&
              logisticTypeOptions.pickup_now
            ) {
              selectedLogisticType = "pickup_now";
            }

            if (
              item.logisticType === "Scheduled Delivery" &&
              logisticTypeOptions.scheduled_delivery
            ) {
              selectedLogisticType = "scheduled_delivery";
            }

            if (
              item.logisticType === "Scheduled Pickup" &&
              logisticTypeOptions.scheduled_pickup
            ) {
              selectedLogisticType = "scheduled_pickup";
            }

            let selectedSchedule = "";

            if (item.scheduledDate)
              selectedSchedule = moment(item.scheduledDate).format(
                "MMM DD, LT"
              );

            item.details = {
              ...this.branchDetails,
              logisticTypeOptions,
              selectedLogisticType,
              selectedSchedule,
            };

            if (!selectedLogisticType) {
              selectedLogisticType = Object.keys(logisticTypeOptions)[0];
              item.details.selectedLogisticType = selectedLogisticType;
              await this.selectBranchLogisticType(
                item,
                selectedLogisticType,
                index
              );
            }
          }
        );
        await Promise.all(branchDetailsPromises);

        this.isBranchDetailsDataLoaded = true;
      } else this.isBranchDetailsDataLoaded = true;
    },
    confirmRemove(key) {
      this.brandBranch.forEach((order, orderIndex) => this.brandBranch[orderIndex].removeAllModal = false);

      if (!this.formattedOrders[key].visible) {
        this.formattedOrders[key].visible = true;
      } else {
        this.formattedOrders[key].visible = false;
      }
    },
    async removeItem(uuid, index) {
      if (this.customerPortalToken != null) {
        let request = {
          header: {
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            cart_items: [this.formattedOrders[index].item_uuid],
            cart_count: this.cart.cart_count,
            cart_total_amount: this.cart.cart_total_amount,
          },
        };

        if (this.loggedIn) request.header["Authorization"] = this.token;
        else if (!this.loggedIn) {
          delete request.payload.cart_count;
          delete request.payload.cart_total_amount;
          request.payload["cart_uuid"] = this.cartUuid;
        }

        await this.$store.dispatch("estore/removeItem", request);
        await this.formatData();
      }
    },
    confirmRemoveAll() {
      this.brandBranch.forEach((order) => {
        this.removeAll(order.branch_uuid);
      });
      this.removeAllModal = false;
    },
    async removeAll(branch_uuid) {
      let uuids = [];
      for (let i = 0; i < this.formattedOrders.length; i++) {
        if (branch_uuid == this.formattedOrders[i].branch_uuid)
          uuids[i] = this.formattedOrders[i].item_uuid;
      }
      if (this.customerPortalToken != null) {
        let request = {
          header: {
            "X-Merchant-Token": this.customerPortalToken,
          },
          payload: {
            cart_items: uuids,
            cart_count: this.cart.cart_count,
            cart_total_amount: this.cart.cart_total_amount,
          },
        };

        if (this.loggedIn) request.header["Authorization"] = this.token;
        else if (!this.loggedIn) {
          delete request.payload.cart_count;
          delete request.payload.cart_total_amount;
          request.payload["cart_uuid"] = this.cartUuid;
        }

        await this.$store.dispatch("estore/removeItem", request);
        await this.formatData();
      }
    },
    showModal(branch_uuid, product_uuid, item_uuid, stock, is_limited_stock) {
      this.$refs.modal.showModal(
        branch_uuid,
        product_uuid,
        item_uuid,
        stock,
        is_limited_stock
      );
    },
    async getBranchDetails(branchUuid) {
      const header = {
        "X-Merchant-Token": this.customerPortalToken,
      };

      if (this.token) header["Authorization"] = this.token;

      await this.$store.dispatch("organization/getBranchDetails", {
        header,
        branchUuid
      });
    },
    showScheduleModal(brandBranch) {
      this.selectedBrandBranch = brandBranch;
      this.$root.$emit("bv::show::modal", "schedule-modal");
    },
    async selectBranchLogisticType(brandBranch, logisticType, index) {
      this.isBranchDetailsDataLoaded = false;
      brandBranch.details.selectedLogisticType = logisticType;
      brandBranch.details.selectedSchedule = null;
      brandBranch.scheduledDate = null;

      this.$nextTick(() => {
        this.isBranchDetailsDataLoaded = true;
      });

      if (logisticType === "deliver_now") {
        await this.updateLogisticType(brandBranch, "Delivery");
      }

      if (logisticType === "pickup_now") {
        await this.updateLogisticType(brandBranch, "Pickup");
      }

      if (logisticType === "scheduled_delivery") {
        this.cart.list[index].delivery_type = "Scheduled Delivery";
        this.cart.list[index].pickup_datetime = null;
      }

      if (logisticType === "scheduled_pickup") {
        this.cart.list[index].delivery_type = "Scheduled Pickup";
        this.cart.list[index].pickup_datetime = null;
      }
    },
    async updateLogisticType(brandBranch, logisticType) {
      const header = {
        "X-Merchant-Token": this.customerPortalToken
      };
      const payload = {
        branchuuid: brandBranch.branch_uuid,
        branch_name: brandBranch.branch,
        brand_uuid: brandBranch.brand_uuid,
        brand_name: brandBranch.brand,
        delivery_type: logisticType
      };

      if (this.token)
        header["Authorization"] = this.token;

      if (this.cartUuid && !this.token)
        payload.cart_uuid = this.cartUuid;

      const request = {
        header,
        payload
      };

      await this.$store.dispatch("estore/updateDelivery", request);
      await this.viewCart();
      await this.formatData();
    },
    addMoreItems(branch, brand) {
      this.$router.push({ path: `/${this.subdomain}/store/${branch}&${brand}` })
    }
  },
  beforeDestroy() {
    this.$root.$off("refreshCartItems");
    this.$root.$off("confirmRemoveAllCartItems");
  },
  watch: {
    source() {
      this.addItemAlignment = "asd";
      console.log(this.addItemAlignment);
    },
    cart() {
      this.formatOrders()
    }
  }
};
</script>

<style scoped lang="scss">
@import "./../../assets/styles/views/cart/_base.scss";

.remove-all-modal {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  width: 180px;
  text-align: center;
  padding: 15px 20px;
  z-index: 2;
  position: absolute;
  right: 10px;
  bottom: -120px;

  label {
    text-align: center;
    font-style: normal;
    font-size: 16px;
    color: #2f3941;
  }

  ul {
    margin: 10px 0px;
    list-style: none;
    padding: 0px;

    li {
      width: 50%;
      display: inline-block;
      font-style: normal;
      font-size: 18px;
      cursor: pointer;

      &:last-child {
        color: $orange;
      }
    }
  }
}

.branchFees {
  color: #87929d;
  font-size: 14px !important;
  padding: 15px 0;
}

.cursor-pointer {
  cursor: pointer;
}

.order-summary-collapse {
  outline: 0;
  transition: all ease 0.2s;

  &.not-collapsed {
    transform: rotate(180deg);
  }
}

#logistics-type {
  height: 40px;
  width: 100%;
  padding: 8px;
  background-color: lightgray;
  position: relative;
  cursor: pointer;
}

#logistics-type-active {
  margin-top: -40px;
  height: 40px;
  width: 100%;
  padding: 8px;
  background-color: lightgray;
  position: relative;
  cursor: pointer;

  .options-container {
    margin-top: 32px;
    margin-left: -7px;
    background: #f0f0f0;
    z-index: 999;
    position: absolute;
    width: 100%;

    div {
      .option {
        cursor: pointer;
        padding: 8px;

        &:hover {
          background: #f9f9f9;
        }
      }
    }
  }
}

.scrollable {
  overflow-y: scroll;
  height: 50vh;
}

.branch-count {
  font-size: 15px !important;
}

.clear-cart {
  padding: 3px !important;
  background-color: transparent !important;
  border-radius: 31px !important;
  min-width: 85px;
  font-size: 12px;
}

#discount-section>div {
  color: #2F3941;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
}

.promo-coupon {
  background-image: url(~@/assets/images/promo-coupon.svg);
  width: 116px;
  height: 24px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.offset-page-header {
  margin-left: -36px;

  .branch-count {
    padding-left: 20px;
  }
}
</style>
